import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { EmopFormItemDataType } from '../../../app/common/EmopFormItemDataType';
import { EmopTableProClass, } from '../../class/EmopTableProClass/EmopTableProClass';
import { EmopTableProHeaderSortOrderEnum } from '../../../app/class/EmopTableProClass/components/EmopTableProHeaderSortOrderEnum';
import { EmopTableProHeaderClass } from '../../../app/class/EmopTableProClass/components/EmopTableProHeaderClass';

@Component({
  selector: 'emop-table-pro',
  templateUrl: './emop-table-pro.component.html',
  styleUrls: ['./emop-table-pro.component.scss']
})


export class EmopTableProComponent implements OnInit {
  constructor() { }
  @Input() dataRef: TemplateRef<any>;
  @Input() data: EmopTableProClass;
  /**
   * 选中项改变后
   * @param data 
   * @param index 
   * @param type 类型 item: 单个选中  all: 所有被选中
   * @param isSelected 是否被选中
   */
  @Output() onSelected = new EventEmitter<{
    data?: any;
    index?: number;
    type: 'item' | 'all';
    isSelected: boolean;
  }>();
  /**
   * 筛选项改变后
   */
  @Output() onSortChange = new EventEmitter<EmopTableProHeaderClass>();
  @Output() onFilterChange = new EventEmitter<EmopTableProHeaderClass>();

  @Output() onPageIndexChange = new EventEmitter();
  @Output() onPageSizeChange = new EventEmitter();
  @Output() onPageChange = new EventEmitter();
  @Output() onTrClick = new EventEmitter();

  currentListData = [];   // 当前显示数据


  onTrClickFn(data: any, index: number) {
    this.onTrClick.emit({ data, index });
  }
  ngOnInit(): void {
    if (!this.data) console.error('Emop-table-pro表格初始化失败\n请传入%cEmopTableProClass', 'background: #aaaaaa50;padding:2px 5px;border-radius:5px;');
    // console.log("this.data", JSON.parse(JSON.stringify(this.data)));

  }

  treeWidth = "100px";
  collapse(array: any[], data: any, $event: boolean): void {
    if ($event && data.children) this.treeWidth = (Number(this.treeWidth.split('p')[0]) + 20) + 'px';
    else {
      if (data.children) {
        this.treeWidth = (Number(this.treeWidth.split('p')[0]) - 20) + 'px';
        data.children.forEach(d => {
          const target = array.find(a => a.key === d.key)!;
          target.expand = false;
          this.collapse(array, target, false);
        });
      } else {
        return;
      }
    }
  }

  /**
   * 多选模式下点击全选
   * @param isSelected 是否被选中
   */
  onAllChecked(isSelected: boolean) {
    if (isSelected) {
      this.data.data.forEach((item, index) => {
        if (this.data.selectedTag === '@index') {
          this.data.selected.push(this.getRealIndex(index));
        } else {
          this.data.selected.push(item[this.data.selectedTag]);
        }
      });
    } else {
      if (this.data.selectedTag === '@index') {
        const indexList = this.data.data.map((item, index) => this.getRealIndex(index));
        this.data.selected = this.data.selected.filter(item => !indexList.includes(item));
      } else {
        const itemList = this.data.data.map(item => item[this.data.selectedTag]);
        this.data.selected = this.data.selected.filter(item => !itemList.includes(item));
      }
    }
    this.onSelected.emit({
      isSelected,
      type: 'all'
    });
  }
  /**
   * 当前该项是否被选中
   * @param data 数据
   * @param index 索引值
   * @returns 
   */
  isSelected(data: object, index: number) {
    if (this.data.selected instanceof Array) {
      return this.data.selected.includes(this.data.selectedTag === '@index' ? index : data[this.data.selectedTag]);
    } else {
      return this.data.selected === (this.data.selectedTag === '@index' ? index : data[this.data.selectedTag]);
    }
  }
  isAllSelected() {
    if (!this.data.data.length) return false;
    return this.data.data.every((item, index) => {
      if (this.data.selectedTag === '@index') {
        return this.data.selected.includes(this.getRealIndex(index));
      } else {
        return this.data.selected.includes(item[this.data.selectedTag]);
      }
    });
  }
  isIndeterminate() {
    if (this.isAllSelected()) {
      return false;
    } else {
      return this.data.data.some((item, index) => {
        if (this.data.selectedTag === '@index') {
          return this.data.selected.includes(this.getRealIndex(index));
        } else {
          return this.data.selected.includes(item[this.data.selectedTag]);
        }
      });
    }
  }
  /**
   * 多选框选中
   * @param isSelected 是否被选中
   * @param data 数据源
   * @param index 索引值
   */
  onCheckboxSelected(isSelected: boolean, data: object, index: number) {
    if (isSelected) {
      if (this.data.selectedTag === '@index') {
        this.data.selected.push(index);
      } else {
        this.data.selected.push(data[this.data.selectedTag]);
      }
    } else {
      this.data.selected = this.data.selected.filter(item => item !== (this.data.selectedTag === '@index' ? index : data[this.data.selectedTag]));
    }
    this.onSelected.emit({
      isSelected,
      data,
      index,
      type: 'item'
    });
  }
  /**
   * 单选框选中
   * @param data 当前行的数据
   * @param index 
   */
  onRadioSelectedFn(data: object, index: number) {
    this.onSelected.emit({
      data,
      index,
      type: 'item',
      isSelected: true
    });
    console.log(this.getRealIndex(index));
  }
  onSortChangeFn(header: EmopTableProHeaderClass) {
    this.onSortChange.emit(header);
  }
  // allChecked: boolean = false;

  // 全选后处理
  // updateAllChecked(header: EmopTableProHeaderClass) {
  //   if (this.allChecked) header.filter.value.forEach(el => el.checked = true);
  //   else header.filter.value.forEach(el => el.checked = false);
  // }
  // 重置
  checkBoxReset(header: EmopTableProHeaderClass) {
    header.filter.value.forEach(el => el.checked = false);
    // this.allChecked = false;
    header.filter.visible = false;
    this.onFilterChangeFn(header);
  }
  // checkBoxModelChange() {
  //   if (this.allChecked) this.allChecked = false;
  //   return;
  // }
  date: any;
  onChange(date: any) {
    console.log("date", date);
  }
  /**
   * 表格筛选
   * @param header 要进行筛选的对应表格头部
   */
  onFilterChangeFn(header: EmopTableProHeaderClass) {
    if (header.filter.mode === "checkbox") {
      header.filter.searchValue = [];
      header.filter.value.filter(el => el.checked)?.forEach(item => { header.filter.searchValue.push(item.value); });
    } else {
      header.filter.searchValue = header.filter.value;
    }
    header.filter.visible = false;
    this.onFilterChange.emit(header);
  }
  emit(emitName: string, data) {
    this[emitName].emit(data);
  }
  pageIndexChange(pageIndex: number) {
    this.onPageIndexChange.emit(pageIndex);
    this.onPageChange.emit();
  }
  pageSizeChange(pageIndex: number) {
    this.onPageSizeChange.emit(pageIndex);
    this.onPageChange.emit();
  }
  /**
   * 因为后端分页的原因,前端的索引值可能并不是正确的数据
   */
  getRealIndex(index: number) {
    if (this.data.frontPagination) {
      return index;
    } else {
      return (this.data.pageInfo.pageIndex - 1) * this.data.pageInfo.pageSize + index;
    }
  }


  onCurrentPageDataChange($event): void {
    this.currentListData = $event;
  }
}
